module.exports = __webpack_public_path__ + "images/emoji/exclamation.c19f65bb94fb7243a702.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/exclamation.png
// module id = E3kp
// module chunks = 14